import farmApi from '@/api/farm.api'

export const farmService = (function () {
  'use strict'

  /**
   * Devuelve una lista de fincas con nombre, para seleccionarlas al dar de alta UE o UM
   * @param {*} enterpriseId 
   */
  async function findForSelector(enterpriseId) {
    try {
      const response = await farmApi.findForSelector(enterpriseId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve los datos para la tabla del ABM de Grupos
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   * @param {*} enterpriseIds
   */
  async function findAll(pageSize, pageNumber, headers = false, enterpriseIds) {
    try {
      const response = await farmApi.findAll(pageSize, pageNumber, headers, enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Devuelve el total de grupos de la collection para el paginador de la tabla del ABM
   */
  async function getTotal(enterpriseIds) {
    try {
      const response = await farmApi.getTotal(enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Para validar el nombre
   * Devuelve true si ya está asignado a un grupo
   * @param {*} name
   * @param {*} enterpriseId
   */
  async function validateFarmName(name, enterpriseId) {
    try {
      if (name) {
        const response = await farmApi.validateFarmName(name, enterpriseId)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  /**
   * Para eliminar un farm
   */
  async function deleteOne(enterpriseId, farmId) {
    await farmApi.deleteOne(enterpriseId, farmId)
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(deletes) {
    await farmApi.deleteMany(deletes)
  }


  /**
   * Crea una nuevo grupo en la collection
   * @param {*} farm
   */
  async function create(farm) {
    await farmApi.create(farm)
  }

  /**
   *  Actualiza un grupo existente en la collection
   * @param {*} farm
   */
  async function update(farm) {
    await farmApi.update(farm)
  }

  /**
   * Verificar si una finca puede ser eliminada
   * Devuelve true si no está asociada a ninguna unidad ecológica
   * @param {*} enterpriseId
   * @param {*} farmId
   */
  async function canDeleteFarm(enterpriseId, farmId) {
    try {
      const response = await farmApi.canDeleteFarm(enterpriseId, farmId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Verificar si un arreglo de fincas puede ser eliminada
   * Devuelve true si ninguna está asociada a una unidad ecológica
   * @param {*} IdsToDelete
   */
  async function canDeleteFarms(idsToDelete) {
    try {
      const response = await farmApi.canDeleteFarms(idsToDelete)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  return {
    findForSelector,
    findAll,
    getTotal,
    validateFarmName,
    deleteOne,
    deleteMany,
    create,
    update,
    canDeleteFarm,
    canDeleteFarms
  }
})()
